// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect} from 'react';

export const Trustpilot_widget = ()=>{
    const domain = `oculusproxies.com${location.pathname}`;
    const trustpilot_url = `https://www.trustpilot.com/review/${domain}`;
    const height = 20;
    useEffect(()=>{
        if (document.querySelector('script[src="https://widget.trustpilot' +
            '.com/bootstrap/v5/tp.widget.bootstrap.min.js"]'))
        {
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://widget.trustpilot.com/bootstrap/v5/' +
            'tp.widget.bootstrap.min.js';
        script.async = true;
        document.head.appendChild(script);
        script.onload = ()=>{
            if (window.Trustpilot)
            {
                const trustbox = document.getElementById('trustbox');
                if (trustbox)
                    window.Trustpilot.loadFromElement(trustbox);
            }
        };
        const schema_script = document.createElement('script');
        schema_script.type = 'application/ld+json';
        schema_script.text = JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'Organization',
            name: 'Oculus Proxies',
            url: `https://www.${domain}`,
            aggregateRating: {
                ratingValue: '4.2',
                reviewCount: '36',
                bestRating: '5',
                worstRating: '1',
            },
            sameAs: [trustpilot_url],
        });
        document.head.appendChild(schema_script);
        return ()=>{
            document.head.removeChild(script);
            document.head.removeChild(schema_script);
        };
    }, [domain]);
    return <div style={{height: `${height}px`}}>
      <div
        className='trustpilot-widget'
        data-locale='en-US'
        data-template-id='5419b732fbfb950b10de65e5'
        data-businessunit-id='65e87600c8ba4ca744f81e9f'
        data-style-height={`${height}px`}
        data-style-width='100%'
        data-schema-type='Organization'>
        <a href={trustpilot_url} target='_blank' rel='noopener noreferrer'></a>
      </div>
    </div>;
};
